import store from '@/store';

export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/',
    name: 'Root',
    redirect: {
      name: 'dashboard'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
      title: '404',
      page: 'page404'
    },
    name: 'NotFound',
    component: () => import('@/views/protocols')
  },
  {
    path: '/403',
    meta: {
      public: true,
      title: '403',
      page: 'page403'
    },
    name: 'AccessDenied',
    component: () => import('@/views/protocols')
  },
  {
    path: '/502',
    meta: {
      public: true,
      title: '502',
      page: 'page502'
    },
    name: 'BadGateway',
    component: () => import('@/views/protocols')
  },
  {
    path: '/login',
    meta: {
      public: true,
      title: 'Login'
    },
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/redirect',
    meta: {
      public: true,
      title: 'Redirecionamento...'
    },
    name: 'redirect',
    component: () => import('@/views/Redirect.vue')
  },
  {
    path: '/redirectExternal',
    meta: {
      public: true,
      title: 'Redirecionamento externo...'
    },
    name: 'redirectExternal',
    component: () => import('@/views/RedirectExternal.vue')
  },
  {
    path: '/redirectExternalAuthenticated',
    meta: {
      public: true,
      title: 'Redirecionamento externo...'
    },
    name: 'redirectExternalAuthenticated',
    component: () => import('@/views/RedirectExternalAuthenticated.vue')
  },
  {
    path: '/dashboard',
    meta: {
      public: false,
      title: 'Início'
    },
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      let config = store.getters['authentication/getConfig'];

      config.DEV_MODULE ? next({ path: '/dev' }) : next();
    }
  },
  {
    path: '/permissions',
    meta: {
      public: false,
      title: 'Permissions'
    },
    name: 'permissions',
    component: () => import('@/views/Permissions.vue'),
    beforeEnter: (to, from, next) => {
      const profile = store.getters['authentication/getUserProfile'];

      if ('role' in profile) {
        profile.role.includes('Admin Vue') ? next() : next({ path: '/403' });
      } else {
        next({ path: '/403' });
      }
    }
  },
  {
    path: '/dev',
    meta: {
      public: false,
      title: 'Page Development'
    },
    name: 'dev',
    component: () => import('@/views/dev/index.vue')
  },
  {
    path: '/page',
    meta: {
      public: false
    },
    name: 'Page',
    props: true,
    component: () => import('@/views/Page.vue')
  },
  {
    path: '/integrated',
    meta: {
      public: true
    },
    name: 'Login Integrado',
    props: true,
    component: () => import('@/views/IntegratedLogin.vue')
  }
];
